const giftCardsEn = {
  "gc.title": "Gift cards",
  "gc.description": "Cards customers bought, cards you issued, and refunds given as gift cards.",
  "gc.issue": "Issue gift card",
  "gc.issued": "Gift card issued",
  "gc.view": "View gift card",
  "gc.code_once": "Copy the code now: you won't see it in full again. Customers redeem it at checkout.",
  "gc.emailed": "The code was emailed.",
  "gc.empty": "Sell and give gift cards",
  "gc.empty_body": "Add a product marked as a gift card to sell them, or issue one yourself for a customer, a giveaway or a refund.",
  "gc.none": "No gift cards match.",
  "gc.all": "All",
  "gc.search": "Search by last 4 characters, customer, email or order",
  "gc.selling_hint": "To sell gift cards, create a product and mark it as a gift card. Each unit bought becomes a card, emailed to the buyer or the person they choose.",
  "gc.status.active": "Active",
  "gc.status.used": "Used up",
  "gc.status.expired": "Expired",
  "gc.status.disabled": "Disabled",
  "gc.source.purchase": "Bought",
  "gc.source.manual": "Issued by staff",
  "gc.source.refund": "Refund",
  "gc.col.code": "Code",
  "gc.col.status": "Status",
  "gc.col.customer": "Customer",
  "gc.col.date": "Date",
  "gc.col.balance": "Balance",
  "gc.col.source": "Source",
  "gc.value": "Value",
  "gc.code": "Code",
  "gc.code_hint": "8 to 20 letters and numbers. Leave empty for a secure random code.",
  "gc.customer": "Customer",
  "gc.recipient_email": "Recipient",
  "gc.recipient_hint": "Send the card to this email instead of the customer's.",
  "gc.message": "Message",
  "gc.expires_on": "Expiry date",
  "gc.expires_hint": "Empty uses the store's default from Features.",
  "gc.no_expiry": "Never expires",
  "gc.note": "Note",
  "gc.note_hint": "Only staff see this.",
  "gc.notify": "Email the code to the recipient or customer",
  "gc.balance": "Balance",
  "gc.of_initial": "of {amount}",
  "gc.history": "History",
  "gc.after": "balance {amount}",
  "gc.txn.issue": "Issued",
  "gc.txn.debit": "Used at checkout",
  "gc.txn.credit": "Given back",
  "gc.txn.adjust": "Adjusted",
  "gc.details": "Details",
  "gc.created": "Created",
  "gc.sent_on": "Sent {when}",
  "gc.sending_on": "Sends {when}",
  "gc.expiry_set": "The card can't be used after this date.",
  "gc.never_expires": "This card never expires.",
  "gc.adjust": "Adjust balance",
  "gc.add_balance": "Add",
  "gc.remove_balance": "Take off",
  "gc.amount": "Amount",
  "gc.reason": "Reason",
  "gc.reason_hint": "Saved in the card's history and the activity log.",
  "gc.disable": "Disable",
  "gc.disable_title": "Disable gift card?",
  "gc.disable_body": "It can't be used at checkout until you enable it again. Its balance is kept.",
  "gc.enable": "Enable",
  "gc.disabled_toast": "Gift card disabled",
  "gc.enabled_toast": "Gift card enabled",
  "gc.refund_to_cards_note": "Gift cards that paid for this order get their amount back first.",
  "gc.refund_as_card": "Refund the rest as a gift card",
  "gc.refund_as_card_hint": "Store credit: a new gift card is emailed to the customer instead of returning the payment.",
} as const;

export default giftCardsEn;
